import { forwardRef } from "react";
import styled from "styled-components";
import css from "@styled-system/css";

import { FilterLinkProps } from "./filterLink.type";
import LinkButton from "../Button/LinkButton";
import Icon from "../Icon/Icon";
import Typography from "../Typography/Typography";

const StyledFilterLink = styled(LinkButton)`
  height: 74px;
  width: 124px;
  flex-wrap: wrap;
  justify-content: space-between;
  ${css({
    pt: 2,
    px: 2,
    pb: 6,
  })}
`;

const Label = styled(Typography)`
  flex: 100%;
  color: inherit;
  ${css({
    fontSize: "body-small"
  })}
`;

const FilterLink = forwardRef<HTMLAnchorElement, FilterLinkProps>(
  (
    {
      label,
      icon,
      iconWeight = "regular",
      url,
      shouldOpenInNewWindow = false,
      analytics,
      ...rest
    },
    ref
  ) => {

  const eventName = analytics ? "click" : undefined;
  const eventCategory = analytics
    ? analytics.eventCategory || "button"
    : undefined;
  
  return (
    <StyledFilterLink
      variant="button"
      ref={ref}
      href={url}
      shouldOpenInNewWindow={shouldOpenInNewWindow}
      data-en={eventName}
      data-ec={eventCategory}
      data-el={analytics?.eventLabel}
      data-ea={analytics?.eventAction}
      data-es={analytics?.eventSection}
      data-et={analytics?.eventType}
      data-ev={analytics?.eventValue}
      {...rest}
    >
      <Icon
        name={icon}
        width="18px"
        weight={iconWeight}
      />
      <Icon
        name="arrow-right"
        width="14px"
        weight="light"
      />
      <Label 
        variant="label"
      >
        {label}
      </Label>
    </StyledFilterLink>
  );
});

export default FilterLink;